import { FC } from "react"
import { useNavigate } from "react-router-dom"

import { STATUS_COLORS } from "components/tournaments/constants"

import { URL } from "constants/api/requests"

import { Tournament } from "types/tournament.types"

interface TournamentHeaderProps {
  tournament: Tournament
  onEndTournament: () => void
}

export const TournamentHeader: FC<TournamentHeaderProps> = ({ tournament, onEndTournament }) => {
  const navigate = useNavigate()

  const timeRemaining = () => {
    const now = new Date()
    const end = new Date(tournament.end_time)
    const diff = end.getTime() - now.getTime()

    if (diff <= 0) return "Ended"

    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

    return `${hours}h ${minutes}m remaining`
  }

  return (
    <div className="p-6 bg-white dark:bg-[#0C0C1A] rounded-xl border border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)] shadow-sm">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{tournament.name}</h2>
          {tournament.description && <p className="text-gray-600 dark:text-gray-400">{tournament.description}</p>}
          <div className="flex items-center space-x-4 mt-4">
            <span className={`px-3 py-1 text-sm font-medium rounded-full ${STATUS_COLORS[tournament.status]}`}>
              {tournament.status.toLowerCase()}
            </span>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Mode: <span className="capitalize font-medium">{tournament.scoring_mode.toLowerCase().replace("_", " ")}</span>
            </span>
            {tournament.status === "ACTIVE" && (
              <span className="text-sm font-medium text-green-600 dark:text-green-400">{timeRemaining()}</span>
            )}
          </div>
        </div>

        <div className="flex space-x-2">
          <button
            onClick={() => navigate(URL.TOURNAMENT.replace(":id", tournament.id))}
            className="px-4 py-2 text-sm border border-[rgba(139,92,246,0.8)] dark:border-[rgba(139,92,246,0.5)] rounded-lg hover:bg-[rgba(139,92,246,0.1)] dark:hover:bg-[rgba(139,92,246,0.1)] text-[rgba(139,92,246,1)] dark:text-white transition-all"
          >
            View Details
          </button>
          {tournament.status === "ACTIVE" && (
            <button
              onClick={onEndTournament}
              className="px-4 py-2 text-sm bg-rose-600 text-white rounded-lg hover:bg-red-700 transition-all"
            >
              End Now
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
